import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function HeaderAcc() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
  const navigate = useNavigate();

  const goTo = (url) => {
    if (url.startsWith("http")) {
      window.location.href = url;
    } else {
      navigate(url); // for internal routes
    }
    setIsMobileMenuOpen(false);
  };

  const navButtonStyle = {
    background: "none",
    border: "none",
    color: "#000",
    fontSize: "14px",
    cursor: "pointer",
    padding: 0,
    whiteSpace: "nowrap",
  };

  useEffect(() => {
    const handleResize = () => setIsMobileView(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <nav
        style={{
          position: "sticky",
          top: 0,
          zIndex: 50,
          width: "100%",
          backgroundColor: "#fafffa",
          borderBottom: "1px solid #ddd",
          padding: "1rem 2rem",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          boxSizing: "border-box",
        }}
      >
        {/* Logo */}
        <button
          onClick={() => goTo("/")}
          style={{
            display: "flex",
            alignItems: "center",
            border: "none",
            background: "none",
            cursor: "pointer",
          }}
        >
          <img
            src={`${process.env.PUBLIC_URL}/images/logo.png`}
            alt="Tama Logo"
            style={{ height: "32px" }}
          />
        </button>

        {/* Desktop Links or Burger Toggle */}
        {isMobileView ? (
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            style={{
              background: "none",
              border: "none",
              fontSize: "24px",
              cursor: "pointer",
              color: "#000",
            }}
          >
            {isMobileMenuOpen ? "✕" : "☰"}
          </button>
        ) : (
          <div style={{ display: "flex", gap: "1.5rem" }}>
            <button
              // onClick={() =>
              //   goTo("https://app.tamayou.com/#/influencerdiscovery")
              // }
              onClick={() => navigate("/influencerdiscovery")}
              style={navButtonStyle}
            >
              Search
            </button>
            <button
              onClick={() => goTo("https://app.tamayou.com/#how-it-works")}
              style={navButtonStyle}
            >
              How It Works
            </button>
            <button
              // onClick={() => goTo("https://app.tamayou.com/#/account/pricing")}
              onClick={() => navigate("/account/pricing")}
              style={navButtonStyle}
            >
              Pricing
            </button>
            <button
              // onClick={() => goTo("https://app.tamayou.com/#/account/login")}
              onClick={() => navigate("/account/login")}
              style={navButtonStyle}
            >
              Login
            </button>
            <button
              onClick={() => (window.location.href = "/#/account/signup")}
              style={{
                ...navButtonStyle,
                fontWeight: "bold",
                background: "linear-gradient(to right, #28a745, #218838)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
              }}
            >
              Join
            </button>
          </div>
        )}
      </nav>

      {/* Mobile Menu */}
      {isMobileView && isMobileMenuOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            width: "75%",
            height: "100%",
            backgroundColor: "#fff",
            zIndex: 40,
            padding: "2rem",
            boxSizing: "border-box",
            boxShadow: "-2px 0 10px rgba(0,0,0,0.1)",
            display: "flex",
            flexDirection: "column",
            gap: "1.5rem",
          }}
        >
          <button
            onClick={() => goTo("/influencer-discovery")}
            style={navButtonStyle}
          >
            Search
          </button>
          <button onClick={() => goTo("/#how-it-works")} style={navButtonStyle}>
            How It Works
          </button>
          <button
            onClick={() => goTo("/account/pricing")}
            style={navButtonStyle}
          >
            Pricing
          </button>
          <button onClick={() => goTo("/account/login")} style={navButtonStyle}>
            Login
          </button>
          <button
            onClick={() => {
              alert("Join modal placeholder");
              setIsMobileMenuOpen(false);
            }}
            style={{
              ...navButtonStyle,
              fontWeight: "bold",
              background: "linear-gradient(to right, #28a745, #218838)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              backgroundClip: "text",
            }}
          >
            Join
          </button>
        </div>
      )}
    </>
  );
}
